export enum ProdutosStatus {
  AGUARDANDO_CALCULO = 'AGUARDANDO_CALCULO',
  AGUARDANDO_COMPENSACAO = 'AGUARDANDO_COMPENSACAO',
  AGUARDANDO_RFB = 'AGUARDANDO_RFB',
  ANALISE = 'ANALISE',
  ATIVO = 'ATIVO',
  AVISO_DE_RECEBIMENTO = 'AVISO_DE_RECEBIMENTO',
  CANCELADO = 'CANCELADO',
  COBRANCA = 'COBRANCA',
  CONTRATO_SUSPENSO = 'CONTRATO_SUSPENSO',
  COMPENSACAO_SUSPENSA = 'COMPENSACAO_SUSPENSA',
  COMPENSADO = 'COMPENSADO',
  CREDITO_ESGOTADO = 'CREDITO_ESGOTADO',
  DADOS_BANCARIOS_INVALIDOS = 'DADOS_BANCARIOS_INVALIDOS',
  DISTRATO = 'DISTRATO',
  DOCUMENTACAO_PENDENTE = 'DOCUMENTACAO_PENDENTE',
  INADIMPLENTE = 'INADIMPLENTE',
  JUDICIAL = 'JUDICIAL',
  NEGATIVADO = 'NEGATIVADO',
  PAGO = 'PAGO',
  PROCURACAO_CANCELADA = 'PROCURACAO_CANCELADA',
  PROCURACAO_EXPIRADA = 'PROCURACAO_EXPIRADA',
  PROTESTADO = 'PROTESTADO',
  RECALCULO = 'RECALCULO',
  SEM_OPORTUNIDADE = 'SEM_OPORTUNIDADE',
  SOLICITANDO_AUTORIZACAO = 'SOLICITANDO_AUTORIZACAO',
  SUSPENSO = 'SUSPENSO'
}

export enum BoletoStatus {
  CANCELADO = 'CANCELADO',
  COBRANCA = 'COBRANCA',
  INADIMPLENTE = 'INADIMPLENTE',
  PAGO = 'PAGO',
  PIX = 'PIX',
  SUBSTITUIDO = 'SUBSTITUIDO'
}

export enum ClientStatus {
  ATIVO = 'ATIVO',
  BLOQUEADO = 'BLOQUEADO',
  INADIMPLENTE = 'INADIMPLENTE',
  NOVO = 'NOVO',
  PROCURACAO_CANCELADA = 'PROCURACAO_CANCELADA',
  PROCURACAO_EXPIRADA = 'PROCURACAO_EXPIRADA',
  INATIVO = 'INATIVO',
  PENDENTE = 'PENDENTE'
}

export enum TypeUsers {
  ADMIN = 'ADMIN',
  USUARIO = 'USUARIO'
}

export enum TypeCargoAdmin {
  ANALISTA = 'ANALISTA',
  FINANCEIRO = 'FINANCEIRO',
  JURIDICO = 'JURIDICO',
  CEO = 'CEO'
}

export enum TypeCargoUser {
  GERENTE = 'GERENTE',
  PARCEIRO = 'PARCEIRO',
  CEO = 'CEO'
}

export enum TypeCargo {
  GERENTE = 'GERENTE',
  PARCEIRO = 'PARCEIRO',
  CEO = 'CEO',
  ANALISTA = 'ANALISTA',
  FINANCEIRO = 'FINANCEIRO',
  JURIDICO = 'JURIDICO'
}

export enum TypeServico {
  DESPESAS_OPERACIONAIS = 'DESPESAS_OPERACIONAIS',
  APURACAO_ST = 'APURACAO_ST',
  NEGOCIACAO_DE_PASSIVOS = 'NEGOCIACAO_DE_PASSIVOS',
  PARCERIA_COMERCIAL = 'PARCERIA_COMERCIAL',
  EQUIPARACAO_HOSPITALAR = 'EQUIPARACAO_HOSPITALAR',
  INSS_MAO_DE_OBRA = 'INSS_MAO_DE_OBRA',
  EXCLUSAO_DE_ICMS_E_ST = 'EXCLUSAO_DE_ICMS_E_ST',
  ALIQUOTA_ZERO_COMBUSTIVEL = 'ALIQUOTA_ZERO_COMBUSTIVEL',
  // MVA = 'MVA',
  // INSUMOS = 'INSUMOS',
  PIS_COFINS_MONOFASICO_PARA_SN = 'PIS_COFINS_MONOFASICO_PARA_SN',
  ALIQUOTA_ZERO = 'ALIQUOTA_ZERO',
  SUBVENCAO = 'SUBVENCAO',
  PREVIDENCIARIO = 'PREVIDENCIARIO',
  FCVS = 'FCVS'
}
